import { Effect } from "effect";

export const succeed = Effect.succeed;

export const fail = Effect.fail;

export const map = (f) => (effect) => Effect.map(effect, f);

export const flatMap = (effect) => (f) => Effect.flatMap(effect, f);

export const tryPromise = (thunk) => (onError) =>
  Effect.tryPromise({
    try: () => thunk(),
    catch: onError,
  });

export const catchAll = (effect) => (handler) => Effect.catchAll(effect, handler);

export const fromIO = (io) => Effect.sync(() => io());
